// @flow
import { useParams } from 'react-router-dom';
import React, { useCallback, useMemo } from 'react';
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { shouldSkipDataFetching } from '@src/common-utils/utils';
import { useGetSPStreamGovernanceWorkloadViewQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';

import { StreamGovernanceWorkloadContext } from './StreamGovernanceWorkloadContext';

export const StreamGovernanceWorkloadContextProvider = ({ children }) => {
  const params = useParams();

  return (
    <DataFetcherContainer
      dataFetchingArgs={useMemo(
        () => [
          { ...params },
          {
            skip: shouldSkipDataFetching(params),
          },
        ],
        [params]
      )}
      dataFetchingFunction={useCallback(useGetSPStreamGovernanceWorkloadViewQuery, [])}
    >
      {(data) => {
        return (
          <StreamGovernanceWorkloadContext.Provider value={data}>
            {children}
          </StreamGovernanceWorkloadContext.Provider>
        );
      }}
    </DataFetcherContainer>
  );
};
